import { create } from 'zustand';

type ThemeMode = 'light' | 'dark' | 'system';
type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;
  toggleTheme: () => void;
}

const applyTheme = (theme: Theme) => {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
    document.documentElement.style.colorScheme = 'dark';
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.style.colorScheme = 'light';
  }
};

// Apply dark immediately at module load — before React renders
document.documentElement.classList.add('dark');
document.documentElement.style.colorScheme = 'dark';

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: 'dark',
  themeMode: 'dark',

  setThemeMode: (mode) => {
    localStorage.setItem('themeMode', mode);
    const theme: Theme = mode === 'light' ? 'light' : 'dark';
    applyTheme(theme);
    set({ themeMode: mode, theme });
  },

  toggleTheme: () => {
    const { themeMode } = get();
    const next: ThemeMode = themeMode === 'dark' ? 'light' : 'dark';
    get().setThemeMode(next);
  },
}));
